
import type {PropType} from 'vue';
import {defineComponent} from 'vue';
// import Text from '@/components/Text/Text.vue';
import Text from '../Text/Text.vue';
// import Icon from '@/components/Icon/Icon.vue';
import Icon from '../Icon/Icon.vue';
import type {TopMenuItem, User, Breadcrumb} from './types';
// import Navigation from '@/components/Topbar/Navigation.vue';
import Navigation from '../Topbar/Navigation.vue';
// import UserDropdown from '@/components/Topbar/UserDropdown.vue';
import UserDropdown from '../Topbar/UserDropdown.vue';
export default defineComponent({
  name: 'OxdTopBar',
  components: {
    'oxd-text': Text,
    'oxd-icon': Icon,
    'oxd-navigation': Navigation,
    'oxd-user-dropdown': UserDropdown,
  },
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: false,
    },
    menuItems: {
      type: Array as PropType<TopMenuItem[]>,
      required: false,
      default: () => [],
    },
    user: {
      type: Object as PropType<User>,
      required: false,
      default: () => ({}),
    },
    breadcrumb: {
      type: Object as PropType<Breadcrumb>,
      required: false,
      default: () => ({}),
    },
  },
  emits: ['collapse'],

  data() {
  return {
    currentURL: window.location.href,
    };
  },

  computed: {
    headerClasses(): object {
      return {
        'oxd-topbar-header': true,
        toggled: this.toggle,
      };
    },
    bodyClasses(): object {
      return {
        'oxd-topbar-body': true,
        toggled: this.toggle,
      };
    },
  },
});
